export const normalizeAddOnKeys = (keys: string[]): string[] => {
  return keys.map((key) => key.replace(/^anu_/, "").replace(/_anu$/, ""));
};
